import React from "react";
import { useTranslation } from "react-i18next";

interface MobileSelectionControlsProps {
  isMobileSelectionMode: boolean;
  onToggleSelectionMode: () => void;
}

const MobileSelectionControls: React.FC<MobileSelectionControlsProps> = ({
  isMobileSelectionMode,
  onToggleSelectionMode,
}) => {
  const { t } = useTranslation("common");

  if (!isMobileSelectionMode) {
    return null;
  }

  return (
    <div className="mobile-selection-controls">
      <button onClick={onToggleSelectionMode}>
        {t("Exit Selection Mode")}
      </button>
    </div>
  );
};

export default MobileSelectionControls;
